/**
 * Lista de 30/10 (B), item 36: textos do filtro "Excluídas" da aba Tarefas da negociação, em `pipeline:crm.excluidas.*`.
 * Arquivo próprio para não brigar com os outros lotes que mexem em `crm-i18n.ts`.
 */
export const excluidasPt = {
  filtro: 'Tarefas excluídas',
  lista: 'Tarefas excluídas da negociação',
  vazio: 'Nenhuma tarefa excluída desta negociação nos últimos 30 dias.',
  selo: 'Excluída',
  excluidaEm: 'Excluída em {{data}}',
  por: 'por {{nome}}',
  porAssistente: 'por {{assistente}}, em nome de {{nome}}',
  justificativa: 'Justificativa: {{texto}}',
  ate: 'Dá para restaurar até {{data}}',
  restaurar: 'Restaurar',
  restaurarTarefa: 'Restaurar a tarefa {{titulo}}',
  restaurada: 'Tarefa restaurada',
  truncado: 'Mostrando as {{n}} tarefas excluídas mais recentes. As demais estão na Lixeira.',
  carregandoTodas: 'Carregando as tarefas excluídas...',
  erroTodas: 'Não foi possível carregar as tarefas excluídas: {{erro}}',
  geralTitulo: 'Tarefas excluídas',
  geralLista: 'Tarefas excluídas, de todas as negociações',
  geralVazio: 'Nenhuma tarefa excluída nos últimos 30 dias com estes filtros.',
  geralCarregando: 'Carregando as tarefas excluídas...',
  carregarMais: 'Carregar mais tarefas excluídas',
  atalhoTitulo: 'Minhas tarefas excluídas',
  atalhoVazio: 'Nenhuma tarefa sua excluída neste dia nos últimos 30 dias.',
  atalhoTodasTitulo: 'Tarefas excluídas de todos',
  atalhoTodasVazio: 'Nenhuma tarefa excluída neste dia nos últimos 30 dias.',
};

export const excluidasEn: typeof excluidasPt = {
  filtro: 'Deleted tasks',
  lista: 'Deleted tasks of the deal',
  vazio: 'No tasks of this deal were deleted in the last 30 days.',
  selo: 'Deleted',
  excluidaEm: 'Deleted on {{data}}',
  por: 'by {{nome}}',
  porAssistente: 'by {{assistente}}, on behalf of {{nome}}',
  justificativa: 'Justification: {{texto}}',
  ate: 'Can be restored until {{data}}',
  restaurar: 'Restore',
  restaurarTarefa: 'Restore the task {{titulo}}',
  restaurada: 'Task restored',
  truncado: 'Showing the {{n}} most recently deleted tasks. The others are in the Trash.',
  carregandoTodas: 'Loading the deleted tasks...',
  erroTodas: 'Could not load the deleted tasks: {{erro}}',
  geralTitulo: 'Deleted tasks',
  geralLista: 'Deleted tasks, from all deals',
  geralVazio: 'No tasks were deleted in the last 30 days with these filters.',
  geralCarregando: 'Loading the deleted tasks...',
  carregarMais: 'Load more deleted tasks',
  atalhoTitulo: 'My deleted tasks',
  atalhoVazio: 'None of your tasks for this day were deleted in the last 30 days.',
  atalhoTodasTitulo: "Everyone's deleted tasks",
  atalhoTodasVazio: 'No tasks for this day were deleted in the last 30 days.',
};

export const excluidasEs: typeof excluidasPt = {
  filtro: 'Tareas eliminadas',
  lista: 'Tareas eliminadas de la negociación',
  vazio: 'Ninguna tarea de esta negociación se eliminó en los últimos 30 días.',
  selo: 'Eliminada',
  excluidaEm: 'Eliminada el {{data}}',
  por: 'por {{nome}}',
  porAssistente: 'por {{assistente}}, en nombre de {{nome}}',
  justificativa: 'Justificación: {{texto}}',
  ate: 'Puedes restaurarla hasta el {{data}}',
  restaurar: 'Restaurar',
  restaurarTarefa: 'Restaurar la tarea {{titulo}}',
  restaurada: 'Tarea restaurada',
  truncado: 'Se muestran las {{n}} tareas eliminadas más recientes. Las demás están en la Papelera.',
  carregandoTodas: 'Cargando las tareas eliminadas...',
  erroTodas: 'No se pudieron cargar las tareas eliminadas: {{erro}}',
  geralTitulo: 'Tareas eliminadas',
  geralLista: 'Tareas eliminadas, de todas las negociaciones',
  geralVazio: 'Ninguna tarea se eliminó en los últimos 30 días con estos filtros.',
  geralCarregando: 'Cargando las tareas eliminadas...',
  carregarMais: 'Cargar más tareas eliminadas',
  atalhoTitulo: 'Mis tareas eliminadas',
  atalhoVazio: 'Ninguna tarea tuya de este día se eliminó en los últimos 30 días.',
  atalhoTodasTitulo: 'Tareas eliminadas de todos',
  atalhoTodasVazio: 'Ninguna tarea de este día se eliminó en los últimos 30 días.',
};
